import SubscriptionPaymentPlan from "./SubscriptionPaymentPlan";
import SubscriptionHistory from "./SubscriptionHistory";

const SubscriptionBillingHistory = () => {
  return (
    <div className="subscriptionBillingHistoryWrapper">
      <SubscriptionPaymentPlan />
      <SubscriptionHistory />
    </div>
  );
};

export default SubscriptionBillingHistory;
